var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2704 14.6118V16.136L9.96979 16.9015L8.67593 16.136V14.6118L9.96979 15.3773L11.2704 14.6118ZM4.22534 9.37546L5.5192 10.1409L5.52597 12.7557L7.74788 14.0631V15.5941L4.22534 13.528V9.37546ZM15.721 9.37546V13.528L12.1985 15.5941V14.0631L14.4204 12.7557L14.4272 10.1409L15.721 9.37546ZM12.1985 7.30258L13.4991 8.06806H13.4923L13.4991 9.59901L11.2704 10.9064V13.528L9.97656 14.2867L8.68271 13.528V10.9064L6.45402 9.59901V8.06806L7.75465 7.30258L9.96979 8.61676L12.1985 7.30258ZM6.45402 10.6829L7.74788 11.4483V12.9725L6.45402 12.2138V10.6829ZM13.4923 10.6829V12.2138L12.1985 12.9725V11.4483L13.4923 10.6829ZM5.5192 5.99518L6.81983 6.76065L5.5192 7.52613V9.0503L4.22534 8.28483V6.76065L5.5192 5.99518ZM14.4204 5.99518L15.721 6.76065V8.28483L14.4204 9.0503V7.52613L13.1265 6.76065L14.4204 5.99518ZM9.96979 5.99518L11.2704 6.76065L9.96979 7.52613L8.67593 6.76065L9.96979 5.99518ZM9.96979 3.38037L13.4923 5.45325L12.1985 6.21872L9.96979 4.90455L7.74788 6.21872L6.45402 5.45325L9.96979 3.38037Z",
    fill: "#F3BA2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3f14f25cbf6aea86e44eae8a40a70481.svg";
export { ForwardRef as ReactComponent };